import React from 'react';
import Lottie from 'lottie-react';
import animation from './animation.json';

const LoginScreenAnimation = () => <Lottie animationData={ animation } />;

export default LoginScreenAnimation;
